import React from "react";
import { NotFound } from "../notFound/NotFound"

export const notfound = type => {
  return (
    <NotFound/>
  )
}


// WEBPACK FOOTER //
// ./pages/static/notfound.jsx